import axios from 'axios';

import { getCookie, removeCookie, setCookie } from './common_function';
let refreshPromise = null;
const instance = axios.create();

instance.interceptors.request.use(
  (config) => {
    const token = getCookie('access_token');
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { config, response } = error;

    const refresh = localStorage.getItem('refresh');
    if ((response?.data?.code === 'user_not_found' || response.data?.detail?.includes("expired")) && response?.status === 401) {
      removeCookie('access_token');
      localStorage.removeItem('refresh');
      window.location.reload();
      return;
    }
    const original = config;
    if (response && response?.status === 401 && refresh) {
      if (!refreshPromise) {
        refreshPromise = axios
          .post('/api/auth/refresh/', {
            refresh: refresh,
          })
          .then((res) => {
            setCookie('access_token', res?.data?.access);
            localStorage.setItem('refresh', res?.data?.refresh);
            instance.defaults.headers.common[
              'Authorization'
            ] = `Bearer ${res?.data?.access}`;
            refreshPromise = null;
            return res?.data?.access;
          })
          .catch((e) => {
            if (error?.response?.status === 401) {
              removeCookie('access_token');
              localStorage.removeItem('refresh');
              window.location.reload();
            }
            refreshPromise = null;
            return Promise.reject(e);
          });
      }
      return refreshPromise.then((newAccessToken: string) => {
        original.headers['Authorization'] = 'Bearer ' + newAccessToken;
        return axios(original);
      });
    }
    return Promise.reject(error);
  },
);

export default instance;
